import { API_URL } from '../../components/config/BaseUrl';

export const LOGGED_IN_URL = `${API_URL}/wificall/loggedOnUser`;
export const DEV_LOGGED_IN_USER_URL = `https://api.tizeti.com/developers/v1/wificall/activeUserDetails`;
